import React from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import FieldWrapper from '../FieldWrapper'
import ImageIcon from '../../../../assets/icons/image-icon.svg'
import UploadIcon from '../../../../assets/icons/upload-icon.svg'

const ImagePickerField = ({ displayName, description, errorMessage, disabled, value, onChange }) => {

  const getCurrentImageSrc = () => {
    if (value) {
      if (typeof value == 'string') return value
      if (value instanceof Blob) return URL.createObjectURL(value) 
    }
    return ImageIcon
  }

  return (
    <FieldWrapper
      displayName={displayName}
      description={description}
      errorMessage={errorMessage}
      disabled={disabled}
    >
      <div className="image-picker-field-container">
        <div className='img-wrapper' style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}>
          <img src={getCurrentImageSrc()} alt="upload" />
        </div>
        {!disabled && (
          <div className="upload-overlay">
            <img src={UploadIcon} alt="upload"/>
            <input type="file"
              onChange={(e) => onChange(e.target.files[0])}
              accept="image/png, image/jpeg"
              disabled={disabled}
            />
          </div>
        )}
      </div>
    </FieldWrapper>
  )
}

ImagePickerField.propTypes = {
  displayName: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default ImagePickerField
